import styled, { css, keyframes } from "styled-components";

interface SkinProps {
  $isGriffle?: boolean;
}

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const TriggerButton = styled.button<SkinProps & { $isOpen: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid ${({ $isGriffle }) => ($isGriffle ? "#e0e7ff" : "#dee2e6")};
  border-radius: 20px;
  background: ${({ $isGriffle }) => ($isGriffle ? "rgba(99, 102, 241, 0.05)" : "#f8f9fa")};
  cursor: pointer;
  transition: all 0.2s;
  font-family: ${({ $isGriffle }) =>
    $isGriffle ? "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" : "inherit"};

  &:hover {
    border-color: ${({ $isGriffle }) => ($isGriffle ? "#6366f1" : "#adb5bd")};
    background: ${({ $isGriffle }) => ($isGriffle ? "rgba(99, 102, 241, 0.1)" : "#e9ecef")};
  }

  ${({ $isOpen, $isGriffle }) =>
    $isOpen &&
    css`
      border-color: ${$isGriffle ? "#6366f1" : "#0d6efd"};
      box-shadow: 0 0 0 2px ${$isGriffle ? "rgba(99, 102, 241, 0.2)" : "rgba(13, 110, 253, 0.15)"};
    `}
`;

export const ClassName = styled.span<SkinProps>`
  font-size: 13px;
  font-weight: 500;
  color: ${({ $isGriffle }) => ($isGriffle ? "#1e1b4b" : "#212529")};
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChevronIcon = styled.span<{ $isOpen: boolean }>`
  display: inline-flex;
  transition: transform 0.2s;
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0)")};
  color: #6c757d;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DropdownPanel = styled.div<SkinProps>`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 220px;
  background: #fff;
  border-radius: ${({ $isGriffle }) => ($isGriffle ? "10px" : "8px")};
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  z-index: 1050;
  animation: ${fadeIn} 0.15s ease-out;
  overflow: hidden;
  font-family: ${({ $isGriffle }) =>
    $isGriffle ? "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" : "inherit"};
`;

export const DropdownTitle = styled.div`
  padding: 10px 14px 6px;
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ClassItem = styled.button<SkinProps & { $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s;

  ${({ $isActive, $isGriffle }) =>
    $isActive
      ? css`
          background-color: ${$isGriffle ? "rgba(99, 102, 241, 0.08)" : "rgba(13, 110, 253, 0.08)"};
        `
      : css`
          &:hover {
            background-color: #f8f9fa;
          }
        `}
`;

export const ClassDot = styled.span<SkinProps & { $isActive: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ $isActive, $isGriffle }) => ($isActive ? ($isGriffle ? "#6366f1" : "#0d6efd") : "#dee2e6")};
`;

export const ClassLabel = styled.span<SkinProps & { $isActive: boolean }>`
  font-size: 13px;
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 400)};
  color: ${({ $isActive, $isGriffle }) => ($isActive ? ($isGriffle ? "#6366f1" : "#0d6efd") : "#212529")};
`;

export const StudentCount = styled.span`
  margin-left: auto;
  font-size: 11px;
  color: #adb5bd;
`;
